import { render, staticRenderFns } from "./OrderListExchanging.vue?vue&type=template&id=52340630&scoped=true"
import script from "./OrderListExchanging.vue?vue&type=script&lang=js"
export * from "./OrderListExchanging.vue?vue&type=script&lang=js"
import style0 from "./OrderListExchanging.vue?vue&type=style&index=0&id=52340630&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52340630",
  null
  
)

export default component.exports